import gtm from 'eco-design-reliance/gtm';
import { ItfGTM30Entire, ItfGTM30 } from './type';

// https://ecoflow.feishu.cn/wiki/GXWPwndwGi5lkMk5fn7cG5CNnXI 新版埋点
export const handle_GTM_30 = (data: ItfGTM30) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'sidebar_remove_from_cart' } as ItfGTM30Entire);
};
